<template>
  <div class="fill-height">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#ff64ad">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="650"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            {{ form.id.length > 0 ? 'Ubah' : 'Tambah' }} Role
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="pt-2 body-1 line-text-second">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <ValidationProvider 
                name="name" 
                rules="required"
                v-slot="{ errors, valid }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Nama
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </p>

                <v-text-field
                  v-on:keyup.enter="save"
                  style="max-width: 70%;"
                  dense
                  outlined
                  color="#ff64ad"
                  hide-details
                  placeholder="Contoh. Disdukcapil"
                  v-model="form.name"
                  v-uppercase
                  :success="form.name !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
              
              <div
                class="my-6">
                <ValidationProvider 
                  name="access" 
                  rules="required"
                  v-slot="{ errors, valid }">
                  <p class="mb-2">
                    <span class="red--text">*</span>
                    Hak Akses
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </p>

                  <v-select
                    v-on:keyup.enter="save"
                    multiple
                    outlined
                    dense
                    color="#ff64ad"
                    placeholder="Contoh. KARTU KELUARGA, KTP-EL"
                    
                    :items="list.role"
                    item-text="name"
                    item-value="role"
                    item-color="#ff64ad"

                    hide-details

                    v-model="form.access"
                    :success="form.access !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Hak Akses {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.access !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <ValidationProvider 
                name="level" 
                rules="required"
                v-slot="{ errors, valid }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Level
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </p>

                <v-select
                  v-on:keyup.enter="save"
                  style="max-width: 55%;"
                  outlined
                  dense
                  color="#ff64ad"
                  placeholder="Contoh. Kabupaten / Kota"
                  
                  :items="[
                    'Kabupaten / Kota',
                    'Kecamatan',
                    'Desa / Kelurahan'
                  ]"
                  item-color="#ff64ad"

                  hide-details

                  v-model="form.level"
                  :success="form.level !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Level {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.level !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <!-- <div v-if="form.level !== ''"
                class="mt-6 mb-3">
                <ValidationProvider 
                  name="kabupaten_code" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Kabupaten
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-autocomplete
                    v-on:keyup.enter="save"
                    style="max-width: 55%;"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    placeholder="Contoh. Klaten"
                    
                    :items="config.city"
                    item-value="kabupaten_code"
                    item-text="kabupaten_name"
                    item-color="#ff64ad"

                    v-model="form.kabupaten_code"
                    :success="form.kabupaten_code !== '' && valid"
                    :error-messages="errors"
                    required>
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Kabupaten / Kota {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.kabupaten_code !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div>

              <div v-if="form.level === 'Kecamatan' || form.level === 'Desa / Kelurahan'"
                class="mt-6 mb-3">
                <ValidationProvider 
                  name="kecamatan_code" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Kecamatan
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-autocomplete
                    v-on:keyup.enter="save"
                    style="max-width: 55%;"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    placeholder="Contoh. Trucuk"

                    :search-input.sync="autocomplete.subdistrict"
                    :loading="process.subdistrict"
                    
                    :items="config.subdistrict"
                    item-value="kecamatan_code"
                    item-text="kecamatan_name"
                    item-color="#ff64ad"

                    v-model="form.kecamatan_code"
                    :success="form.kecamatan_code !== '' && valid"
                    :error-messages="errors"
                    required>
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Kecamatan {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.kecamatan_code !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div>

              <div v-if="form.level === 'Desa / Kelurahan'"
                class="mt-6 mb-3">
                <ValidationProvider 
                  name="kelurahan_code" 
                  rules="required" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Desa / Kelurahan
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-autocomplete
                    v-on:keyup.enter="save"
                    style="max-width: 55%;"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    placeholder="Contoh. Kradenan"

                    :search-input.sync="autocomplete.village"
                    :loading="process.village"
                    
                    :items="config.village"
                    item-value="desa_code"
                    item-text="desa_name"
                    item-color="#ff64ad"

                    v-model="form.kelurahan_code"
                    :success="form.kelurahan_code !== '' && valid"
                    :error-messages="errors"
                    required>
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Desa / Kelurahan {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.kelurahan_code !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div> -->
            </v-form>
          </ValidationObserver>

          <v-alert 
            type="error" 
            text dense prominent 
            class="mt-6"
            v-show="message.error.length > 0">
            {{  message.error }}
          </v-alert>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Hapus Data
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data Role yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat 
            style="border: 1px solid #E0E0E0;">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8" class="d-flex align-center">
                  <!-- ADD -->
                  <div class="mr-3">
                    <v-btn
                      elevation="0"
                      style="background: #00acc133;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                      @click="dialog.form = true; reset();">
                      <v-icon size="18">mdi-plus-circle-outline</v-icon>

                      <span class="ml-1">
                        Tambah Role
                      </span>
                    </v-btn>
                  </div>

                  <!-- EDIT -->
                  <div class="mr-3" v-if="selected.row.length === 1">
                    <v-btn 
                      elevation="0"
                      style="background: #2196f333;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                      @click="dialog.form = true; reset(selected.row[0]);">
                      <v-icon size="18">mdi-circle-edit-outline</v-icon>

                      <span class="ml-1">
                        Ubah
                      </span>
                    </v-btn>
                  </div>

                  <!-- DELETE -->
                  <div class="mr-3" v-if="selected.row.length > 0">
                    <v-btn
                      elevation="0"
                      style="background: #f4403433;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                      @click="toDelete()">
                      <v-icon size="18">mdi-delete-circle-outline</v-icon>

                      <span class="ml-1">
                        Hapus
                      </span>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="d-flex align-center justify-end">
                  <v-text-field 
                    class="mr-3"
                    dense
                    single-line
                    hide-details
                    color="#ff64ad"
                    placeholder="Cari . . ."
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search"
                    v-uppercase
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid text-capitalize"
              :height="`calc(100vh - ${pagination.total_data > 0 ? '330px' : '258px'})`"
              :show-select="true"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="headers"
              :items="list.data"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              hide-default-footer>
              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          form: false,
          delete: false
        },
        search: '',
        selected: {
          row: [],
          delete: []
        },
        config: {
          city: [{
            kabupaten_code: '33.10',
            kabupaten_name: 'KLATEN'
          }],
          subdistrict: [],
          village: []
        },
        autocomplete: {
          city: '',
          subdistrict: '',
          village: ''
        },
        options: {},
        headers: [],
        list: {
          role: [],
          data: []
        },
        limit: 20,
        pagination: {},
        lastIndex: 0,
        form: {
          id: '',
          name: '',
          access: '',
          level: '',
          // kabupaten_name: 'KLATEN',
          // kabupaten_code: '33.10',
          // kecamatan_name: '',
          // kecamatan_code: '',
          // kelurahan_name: '',
          // kelurahan_code: ''
        },
        process: {
          load: false,
          form: false,
          delete: false,
          city: false,
          subdistrict: false,
          village: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },
      // 'form.level': function() {
      //   this.form.kabupaten_code = '33.10'
      //   this.form.kabupaten_name = 'KLATEN'
      //   this.form.kecamatan_code = ''
      //   this.form.kecamatan_name = ''
      //   this.form.kelurahan_code = ''
      //   this.form.kelurahan_name = ''
      // },
      // 'form.kabupaten_code': function() {
      //   let t = this
      //   let kab = this.config.city.filter(function(v) {
      //     return t.form.kabupaten_code == v.kabupaten_code
      //   })

      //   if (kab.length > 0) {
      //     this.form.kabupaten_name = kab[0].kabupaten_name

      //     this.form.kecamatan_code = ''
      //     this.form.kecamatan_name = ''
      //     this.form.kelurahan_code = ''
      //     this.form.kelurahan_name = ''
      //   }

      //   this.static().subdistrict()
      // },
      // 'form.kecamatan_code': function() {
      //   let t = this
      //   let kec = this.config.subdistrict.filter(function(v) {
      //     return t.form.kecamatan_code == v.kecamatan_code
      //   })

      //   if (kec.length > 0) {
      //     this.form.kecamatan_name = kec[0].kecamatan_name

      //     this.form.kelurahan_code = ''
      //     this.form.kelurahan_name = ''
      //   }

      //   this.static().village()
      // },
      // 'form.kelurahan_code': function() {
      //   let t = this
      //   let kel = this.config.village.filter(function(v) {
      //     return t.form.kelurahan_code == v.desa_code
      //   })

      //   if (kel.length > 0) {
      //     this.form.kelurahan_name = kel[0].desa_name
      //   }
      // },
      // 'autocomplete.subdistrict': function() {
      //   this.static().subdistrict()
      // },
      // 'autocomplete.village': function() {
      //   this.static().village()
      // }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get('user_role', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nama',
                width: '200px',
                value: 'user_role_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Hak Akses',
                width: '400px',
                value: 'user_role_access',
                freeze: false,
                hide: false
              }
            ]
            
            this.list.data = res.data
            this.pagination = res.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1
          }
        })
      },
      async fetchRole () {
        await get('master/user_level_access')
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.list.role = res.data
          }
        })
      },
      static () {
        let t = this
        return {
          async subdistrict () {
            t.process.subdistrict = true

            let params = {
              search: t.autocomplete.subdistrict,
              sort: 'DESC'
            }

            await get('location/kecamatan', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.subdistrict = false

                t.config.subdistrict = res.data
              }
            })
          },
          async village () {
            t.process.village = true

            let params = {
              desa_kecamatan_code: t.form.kecamatan_code,
              search: t.autocomplete.village,
              sort: 'DESC'
            }

            await get('location/desa', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.village = false

                t.config.village = res.data
              }
            })
          }
        }
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          name: item !== undefined ? item.user_role_name : '',
          access: item !== undefined  ? item.user_role_access.split(',') : '',
          level: item !== undefined ? item.user_role_level : '',
          // kabupaten_name: item !== undefined ? item.user_role_kabupaten_name : '',
          // kabupaten_code: item !== undefined ? item.user_role_kabupaten_code : '',
          // kecamatan_name: item !== undefined ? item.user_role_kecamatan_name : '',
          // kecamatan_code: item !== undefined ? item.user_role_kecamatan_code : '',
          // kelurahan_name: item !== undefined ? item.user_role_kelurahan_name : '',
          // kelurahan_code: item !== undefined ? item.user_role_kelurahan_code : ''
        }
        
        this.process.form = false

        this.message.error = ''

        this.fetchRole()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          this.form.access = this.form.access.toString()

          let url = this.form.id.length < 1 ? 'user_role/create' : 'user_role/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true

              this.message.success = res.message

              this.fetch()
            } else {
              this.form.access = this.form.access !== ''  ? this.form.access.split(',') : this.form.access
              
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete () {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('user_role/delete', {
          data: {
            ids: this.selected.delete
          }
        }).then(response => {
          let res = response.data

          if (res.code === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>